// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_in_stock_only_false_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Include shoes that will be available within 2-3 weeks.`
};

const el_in_stock_only_false_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Συμπεριέλαβε και παπούτσια που θα είναι διαθέσιμα σε 2-3 εβδομάδες.`
};

const ru_in_stock_only_false_expl = /** @type {(inputs: {}) => string} */ () => {
	return `Включить обувь, которая будет доступна в течение 2-3 недель.`
};

const he_in_stock_only_false_expl = /** @type {(inputs: {}) => string} */ () => {
	return `כלול נעליים שיהיו זמינות תוך 2-3 שבועות.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const in_stock_only_false_expl = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.in_stock_only_false_expl(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("in_stock_only_false_expl", locale)
	if (locale === "en") return en_in_stock_only_false_expl(inputs)
	if (locale === "el") return el_in_stock_only_false_expl(inputs)
	if (locale === "ru") return ru_in_stock_only_false_expl(inputs)
	if (locale === "he") return he_in_stock_only_false_expl(inputs)
	return "in_stock_only_false_expl"
};